export const getQuerystringResolution = (search: string) =>
  search?.split('Formation+Period=')[1]?.split('&')[0] ||
  search?.split('Time+Resolution=')[1]?.split('&')[0] ||
  search?.split('Formation%20Period=')[1]?.split('&')[0] ||
  search?.split('Time%20Resolution=')[1]?.split('&')[0];
